export default "__VITE_ASSET__38a50286__"